/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type IssueViewEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const issueViewEntryPoint: EntryPoint<IssueViewEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<IssueViewEntryPointComponent>(
		/* webpackChunkName: "async-issue-app--full-page", jiraSpaEntry: "spa-issue" */ './IssueViewWithRedirect.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
